import { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { State, SortParamsArg } from 'models';
import { setInvestorBankAccountsSortParams } from 'store/investor-bank-accounts/action-creators';
import { fetchInvestorBankAccounts } from 'store/investor-bank-accounts/actions';
import {
  selectSortParams,
  getBankAccounts,
} from 'store/investor-bank-accounts/selectors';
import { investorBankAccounts } from 'configs';

import { BankAccountsDetails } from 'components';

const InvestorBankAccounts = () => {
  const dispatch = useDispatch();
  const { coopId, sortParams, bankAccounts, loading, error } = useSelector(
    (state: State) => ({
      coopId: state.settings.current_cooperative,
      sortParams: selectSortParams(state),
      bankAccounts: getBankAccounts(state),
      loading: state.investorBankAccounts.loading,
      error: state.investorBankAccounts.error,
    })
  );

  useEffect(() => {
    if (coopId) {
      dispatch(fetchInvestorBankAccounts(coopId));
    }
  }, [coopId, dispatch]);

  const handleChangeSortParams = useCallback(
    (params: SortParamsArg) => {
      dispatch(setInvestorBankAccountsSortParams(params));
    },
    [dispatch]
  );

  return (
    <BankAccountsDetails
      bankAccounts={bankAccounts}
      handleChangeSortParams={handleChangeSortParams}
      sortParams={sortParams}
      loading={loading}
      error={error}
      tableCells={investorBankAccounts}
      title={'Pankkitilien saldot'}
    />
  );
};

export default InvestorBankAccounts;
